import { render, staticRenderFns } from "./ManageProjectTypes.vue?vue&type=template&id=49c0c7e8"
import script from "./ManageProjectTypes.vue?vue&type=script&lang=js"
export * from "./ManageProjectTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports